/** ReSTIR 新規候補に入れる短い SDF 可視性。 */

export const CHEAP_SDF_MAX_STEPS = 8;

export const DEFAULT_RESTIR_CHEAP_CANDIDATE_VISIBILITY = true;

export function resolveRestirFlag(value: string | null | undefined, fallback: boolean): boolean {
  if (value === '1') return true;
  if (value === '0') return false;
  return fallback;
}
